<template>
  <footer class="bg-gray-900 text-white py-12 px-6">
    <div class="max-w-screen-xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
        <!-- PRODUCT Column -->
        <div class="footer-section">
          <h3
            class="text-base font-bold mb-4 tracking-wide uppercase flex justify-between items-center cursor-pointer md:cursor-default"
            @click="toggleSection('product')"
          >
            PRODUCT
            <span
              class="md:hidden transition-transform duration-200"
              :class="{ 'rotate-180': openSections.product }"
            >
              ▼
            </span>
          </h3>
          <ul
            class="space-y-2 overflow-hidden transition-all duration-300 md:!max-h-none md:!opacity-100"
            :class="{
              'max-h-0 opacity-0': !openSections.product,
              'max-h-96 opacity-100': openSections.product,
            }"
          >
            <li
              v-for="item in footerProduct"
              :key="item.id"
              class="cursor-pointer"
            >
              <a
                @click="jump(`/product-detail?id=${item.id}`)"
                class="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>

        <!-- SUPPORT Column -->
        <div class="footer-section">
          <h3
            class="text-base font-bold mb-4 tracking-wide uppercase flex justify-between items-center cursor-pointer md:cursor-default"
            @click="toggleSection('support')"
          >
            SUPPORT
            <span
              class="md:hidden transition-transform duration-200"
              :class="{ 'rotate-180': openSections.support }"
            >
              ▼
            </span>
          </h3>
          <ul
            class="space-y-3 md:block overflow-hidden transition-all duration-300"
            :class="{
              'max-h-0 opacity-0': !openSections.support,
              'max-h-96 opacity-100': openSections.support,
            }"
          >
            <li>
              <a
                href="/support"
                class="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Product Support
              </a>
            </li>

            <li>
              <a
                href="/company-info"
                class="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                href="#"
                class="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Shipping Policy
              </a>
            </li>
          </ul>
        </div>

        <!-- CUSTOMER SERVICE Column -->
        <div class="footer-section">
          <h3
            class="text-base font-bold mb-4 tracking-wide uppercase flex justify-between items-center cursor-pointer md:cursor-default"
            @click="toggleSection('customer')"
          >
            CUSTOMER SERVICE
            <span
              class="md:hidden transition-transform duration-200"
              :class="{ 'rotate-180': openSections.customer }"
            >
              ▼
            </span>
          </h3>
          <ul
            class="md:block overflow-hidden transition-all duration-300"
            :class="{
              'max-h-0 opacity-0': !openSections.customer,
              'max-h-96 opacity-100': openSections.customer,
            }"
          >
            <li>
              <a
                class="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Company: FORTVUE LIMITED
              </a>
            </li>
            <li>
              <a
                class="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Address: FLAT/RM A 12/F ZJ 300 300LOCKHART RD WAN CHAI HONG KONG
              </a>
            </li>
            <li>
              <a
                class="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Email: support@fortvue.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Copyright -->
      <div class="mt-8 pt-6 border-t border-gray-700 text-center">
        <p class="text-gray-400 text-sm">
          COPYRIGHT © 2020 SHENZHEN CITY HAISIHUI TRADE LIMITED All RIGHT
          RESERVED.
        </p>
      </div>
    </div>
  </footer>
</template>

<script lang="js">
import {footerProduct} from "../data/data"
export default {
  name: "FooterPage",
  data() {
    return {
      openSections: {
        product: false,
        support: false,
        customer: false,

      },
      footerProduct:footerProduct,
    };
  },
  methods: {
    toggleSection(section) {
      if (window.innerWidth < 768) {
        this.openSections[section] = !this.openSections[section];
      }
    },
    jump(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
/* 如果需要自定义背景色以更接近截图，可以使用 */
footer {
  background-color: #101820; /* 深灰蓝色 */
  font-family: Open Sans, sans-serif;
}

footer > div {
  max-width: 1200px;
}

/* PC 端强制显示所有内容 */
@media (min-width: 768px) {
  ul {
    max-height: none !important;
    opacity: 1 !important;
  }
}
</style>
